import { useMutation, useQuery } from "@tanstack/react-query";
import { EXPIRED_PRACTICES_QUERY_KEY } from "../config";

export const useExpiredPracticeActionHistoryQueryObserver = (id: string) => {
    return useQuery({
        queryKey: [EXPIRED_PRACTICES_QUERY_KEY.FETCH_EXPIRED_PRACTICE_ACTION_HISTORY, {id: id}],
        enabled: false
    });
};

export const useGetAvaiableExpiredActionQueryObserver = () => {
    return useQuery({
        queryKey: [EXPIRED_PRACTICES_QUERY_KEY.GET_AVAIABLE_EXPIRED_ACTIONS],
        enabled: false
    });
};